import { useLocales } from 'src/contexts'

import { useAppSelector } from 'src/hooks/useAppSelector'

import { useAuthLayout } from 'src/features/AuthLayout/useAuthLayout'

export const useRegistrationPopup = () => {
  const { handleClose, handleFillAutoRoute, handleHome } = useAuthLayout()
  const { translations } = useLocales()
  const showPopupState = useAppSelector(
    state => state.auth.showRegistrationPopup,
  )

  return {
    handleClose,
    handleFillAutoRoute,
    handleHome,
    translations,
    showPopupState,
  }
}
